import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ChipToggleComponent } from '../../../../shared/payee-cases/chip-toggle/chip-toggle.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-payee-case-mokk-without-transition-log-filter',
  templateUrl: './payee-case-mokk-without-transition-log-filter.component.html',
  imports: [ChipToggleComponent, TranslateModule],
})
export class PayeeCaseMokkWithoutTransitionLogFilterComponent {
  @Input({ required: true }) control!: FormControl<boolean>;
}
